import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Link({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14.1261 17.262L12.6691 18.719C12.1702 19.2182 11.5778 19.6143 10.9258 19.8845C10.2737 20.1547 9.57486 20.2938 8.86906 20.2938C8.16326 20.2938 7.46438 20.1547 6.81236 19.8845C6.16033 19.6143 5.56795 19.2182 5.06906 18.719C4.56992 18.22 4.17396 17.6276 3.90382 16.9756C3.63367 16.3236 3.49463 15.6247 3.49463 14.919C3.49463 14.2132 3.63367 13.5144 3.90382 12.8624C4.17396 12.2103 4.56992 11.6179 5.06906 11.119L6.53006 9.66598M8.89506 14.897L15.1051 8.68698M9.87406 6.32198L11.3311 4.86498C11.8298 4.36548 12.4222 3.96921 13.0742 3.69884C13.7262 3.42847 14.4252 3.28931 15.1311 3.28931C15.8369 3.28931 16.5359 3.42847 17.1879 3.69884C17.84 3.96921 18.4323 4.36548 18.9311 4.86498C19.4303 5.36387 19.8264 5.95625 20.0966 6.60828C20.3668 7.2603 20.5059 7.95918 20.5059 8.66498C20.5059 9.37078 20.3668 10.0697 20.0966 10.7217C19.8264 11.3737 19.4303 11.9661 18.9311 12.465L17.4701 13.918" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Link;